import { render, staticRenderFns } from "./VideoHome.vue?vue&type=template&id=635d9dd0&scoped=true&"
import script from "./VideoHome.vue?vue&type=script&lang=js&"
export * from "./VideoHome.vue?vue&type=script&lang=js&"
import style0 from "./VideoHome.vue?vue&type=style&index=0&id=635d9dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d9dd0",
  null
  
)

export default component.exports